import React from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import {
  Box,
  Grid,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import { Add, Style } from "@mui/icons-material";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%", // previously 35%
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  borderRadius: "8px",
};
const UpdateSingleLeaveModal = ({ leave, refresh, leaveType, leaveName }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      [leaveType]: leave?.[leaveType] || 0,
      [`total_${leaveType}`]: leave?.[`total_${leaveType}`] || 0,
    },
  });

  const handleOpen = () => {
    reset({
      [leaveType]: leave?.[leaveType] || 0,
      [`total_${leaveType}`]: leave?.[`total_${leaveType}`] || 0,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const onSubmit = (data) => {
    const payload = {
      user_id: leave?.user_id,
      [leaveType]: parseFloat(data[leaveType]) || 0,
      [`total_${leaveType}`]: parseFloat(data[`total_${leaveType}`]) || 0,
    };

    postJsonData(
      ApiEndpoints.UPDATE_DEVELOPER_LEAVE,
      payload,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message);
        handleClose();
        if (refresh) refresh();
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  return (
    <div>
<Tooltip title="Update Leave" placement="top" arrow>
  <IconButton
    onClick={handleOpen}
    sx={{
      p: 0.5,
      backgroundColor: 'rgba(99, 102, 241, 0.08)',
      border: '1px solid rgba(99, 102, 241, 0.2)',
      borderRadius: '8px',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
        transform: 'scale(1.08)',
        boxShadow: '0 2px 8px rgba(99, 102, 241, 0.25)',
        border: '1px solid rgba(99, 102, 241, 0.4)',
      }
    }}
    size="small"
  >
    <Add 
      sx={{ 
        color: "#6366F1", 
        fontSize: "16px",
        fontWeight: 'bold'
      }} 
    />
  </IconButton>
</Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box sx={{ ...style, width: 400 }}>
          <ModalHeader
            title={`Update ${leaveName}`}
            handleClose={handleClose}
          />
          <Typography variant="subtitle1" gutterBottom>
            <strong>Employee:</strong> {leave?.emp_name} (ID: {leave?.user_id})
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Controller
                  name={`total_${leaveType}`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label={`Total ${leaveName}`}
                      type="number"
                      fullWidth
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name={leaveType}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label={`Current ${leaveName} Balance`}
                      type="number"
                      fullWidth
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                      helperText="Enter the remaining leave balance"
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Box mt={2}>
              <ModalFooter
                btn={`Update ${leaveName}`}
                onClick={handleSubmit(onSubmit)}
              />
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};
export default UpdateSingleLeaveModal;
